import { render, staticRenderFns } from "./PriceAdjustment.vue?vue&type=template&id=49ef3a45&scoped=true&"
import script from "./PriceAdjustment.vue?vue&type=script&lang=js&"
export * from "./PriceAdjustment.vue?vue&type=script&lang=js&"
import style0 from "./PriceAdjustment.vue?vue&type=style&index=0&id=49ef3a45&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ef3a45",
  null
  
)

export default component.exports